import React from 'react'
import { makeStyles } from '@material-ui/styles'

import DropdownField from 'core/components/validatedForm/DropdownField'
import KeyValuesField from 'core/components/validatedForm/KeyValuesField'
import TextField from 'core/components/validatedForm/TextField'
import ToggleSwitchField from 'core/components/validatedForm/ToggleSwitchField'
import Theme from 'core/themes/model'
import NamespacePicklist from 'k8s/components/common/NamespacePicklist'
import { keyValueArrToObj, objToKeyValueArr } from 'utils/fp'
import Text from 'core/elements/Text'

const useStyles = makeStyles<Theme>((theme) => ({
  fields: {
    display: 'grid',
    gap: 24,
  },
  configurations: {
    display: 'grid',
    gap: 16,
  },
  switchTooltip: {
    padding: theme.spacing(1),
    color: theme.palette.common.white,
  },
}))

export default function ConfigMapParamFields({ params, updateParams }) {
  const classes = useStyles()

  return (
    <>
      <TextField
        id="name"
        label="Name"
        value={params?.name}
        onChange={(value) => updateParams({ name: value })}
        required
        data-testid="config-map-name-field"
      />
      <DropdownField
        DropdownComponent={NamespacePicklist}
        id="namespace"
        label="Namespace"
        clusterId={params?.clusterId}
        value={params?.namespace}
        onChange={(value) => updateParams({ namespace: value })}
        selectFirst={false}
        showAll={false}
        required
        data-testid="config-map-namespace-picker"
      />
      <ToggleSwitchField
        id="immutable"
        label="Immutable"
        value={params?.immutable}
        onChange={(value) => updateParams({ immutable: value })}
        customTooltipInfoBody={
          <Text variant="body2" className={classes.switchTooltip}>
            Immutable, if set to true, ensures that data stored in the Config Map cannot be updated
            (only object metadata can be modified)
          </Text>
        }
        data-testid="config-map-immutable-switch"
      />
      <div>
        <KeyValuesField
          id="data"
          label="Add Data"
          value={objToKeyValueArr(params?.data)}
          onChange={(value) => updateParams({ data: keyValueArrToObj(value) })}
          addLabel="Add key/value"
          allowMultipleValues
          data-testid="config-map-data-key-values"
        />
      </div>
      <div>
        <KeyValuesField
          id="binaryData"
          label="Add Binary Data"
          value={objToKeyValueArr(params?.binaryData)}
          onChange={(value) => updateParams({ binaryData: keyValueArrToObj(value) })}
          addLabel="Add key/value"
          allowMultipleValues
          data-testid="config-map-binary-data-key-values"
        />
      </div>
    </>
  )
}
